import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';
import { BlogHomeSubtitleElementDataType } from '@/components/sections/builder/elements/body/blog-home/type';
import { getOverrideAnimationParams } from '@/components/sections/builder/settings/animation-setting';
import InputSelect from '@/components/sections/builder/settings/input-select';
import PaddingSetting from '@/components/sections/builder/settings/padding-setting';
import { ElementProps } from '@/components/sections/builder/types';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';
import { useBuilderStore } from '@/stores/builder';
import { Type } from 'lucide-react';
import { shallow } from 'zustand/shallow';

const defaultData: BlogHomeSubtitleElementDataType = {
  name: 'Sub Title',
  label:
    'We use an agile approach to test assumptions and connect with the needs of your audience early and often.',
  textStyle: 'body',
  padding: {
    bottom: 16,
    top: 1,
    left: 1,
    right: 1,
  },
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as BlogHomeSubtitleElementDataType;

  return (
    <>
      <p
        data-animation='true'
        {...getOverrideAnimationParams(data.animation)}
        className={cn(
          'p-3',
          'lg:pb-[--p-bottom] lg:pl-[--p-left] lg:pr-[--p-right] lg:pt-[--p-top]',
          data.textStyle === 'body' && 'text-base md:text-lg lg:text-xl',
          data.textStyle === 'subtitle' && 'text-sm md:text-base lg:text-lg',
          data.textStyle === 'uppercase' && 'text-xs uppercase md:text-sm lg:text-base'
        )}
        dangerouslySetInnerHTML={{ __html: data.label }}
        style={
          {
            '--p-top': `${data.padding?.top || 0}px`,
            '--p-bottom': `${data.padding?.bottom || 0}px`,
            '--p-left': `${data.padding?.left || 0}px`,
            '--p-right': `${data.padding?.right || 0}px`,
          } as React.CSSProperties
        }
      />
    </>
  );
};

export const ElementPreviewIcon = Type;

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as BlogHomeSubtitleElementDataType;

  return (
    <div>
      <h1 className='mb-3 text-sm font-bold'>Section Header</h1>
      <div className='mb-3 flex flex-col gap-2'>
        <h4>Text</h4>
        <TextEditorMinimal
          onChange={(value) =>
            builder.setChildData(element.parentId as string, element.id, {
              label: value,
            })
          }
          value={data.label}
          placeholder='Label'
          className='mb-2 w-full '
          output='html'
          editorProps={{
            attributes: {
              class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
            },
          }}
          editable
        />
      </div>
      <div className='mb-3 grid grid-cols-2 items-center gap-2'>
        <h4>Text Style</h4>
        <InputSelect
          defaultValue={data.textStyle || defaultData.textStyle}
          options={[
            { label: 'Body', value: 'body' },
            { label: 'Subtitle', value: 'subtitle' },
            { label: 'UPPERCASE', value: 'uppercase' },
          ]}
          onChange={(v) =>
            builder.setChildData(element.parentId as string, element.id, { textStyle: v })
          }
        />
      </div>

      <Separator className='my-4' />

      <h1 className='mb-3 text-sm font-bold'>Style</h1>
      <PaddingSetting
        value={data.padding}
        hideLeft={true}
        hideRight={true}
        onChange={(v) =>
          builder.setChildData(element.parentId as string, element.id, {
            padding: v,
          })
        }
      />
    </div>
  );
}

const BlogHomeSubtitle = {
  type: 'blog_home_subtitle',
  group: 'blog_home',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default BlogHomeSubtitle;
